<ion-content>
  <ion-list>
    <ion-item *ngFor="let listItem of list" (click)="onMenuItem(listItem)" lines="full" [button]="true">
      <ion-icon class="menu-icon" [src]="listItem.icon" [style.color]="listItem.iconColor" slot="start"></ion-icon>
      <ion-label>{{listItem.label}}</ion-label>
      <ion-icon *ngIf="listItem.rightSlot?.icon" class="menu-icon" [src]="listItem.rightSlot?.icon"
        [style.color]="listItem.rightSlot?.iconColor" slot="end"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>